const HOME = '/';
const ABOUT = '/about';
const CONTACTS = '/contacts';
const KLEVIYE = '/kleviye';
const RIBPROM = '/ribprom';
const BRAMA = '/brama';
const PRODUCT_PAGE = '/product/:productName';

export {
  HOME,
  ABOUT,
  CONTACTS,
  KLEVIYE,
  RIBPROM,
  BRAMA,
  PRODUCT_PAGE
}